import { render, staticRenderFns } from "./SegmentationRow.vue?vue&type=template&id=5609abd4&scoped=true"
import script from "./SegmentationRow.vue?vue&type=script&lang=js"
export * from "./SegmentationRow.vue?vue&type=script&lang=js"
import style0 from "./SegmentationRow.vue?vue&type=style&index=0&id=5609abd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5609abd4",
  null
  
)

export default component.exports